<div [style.height.px]="this.sizeIcon">
    @for (badge of badges; track badge){
        <span class="tooltip1">
            <img class="hof-badge" src="{{ 'assets/badges/' + badge.nom +'.svg' }}" alt="{{ badge.nom }}" [style.width.px]="this.sizeIcon" />
            @if (tooltip) {
                <div class="top">
                    {{ badge.description }}<i></i>
                </div>
              }
        </span>
    }
</div>